import dayjs from "dayjs"

/**
 * Convert temperature values between Celsius and Fahrenheit.
 *
 * @param {number|string} val - The temperature value need to convert.
 * @param {number} target - The target temperature unit (1 for ℃, 2 for ℉).
 * @param {number} [source=1] - The current temperature unit (1 for ℃, 2 for ℉).
 * @param {boolean} [isTempDiff=false] - Indicates if the conversion is for temperature difference.
 * @returns {number|string} The converted temperature value or the original input if invalid.
 */
export const convertTempList = (list, target = 2, source = 1, isTempDiff = 0) => {
  if (target == source) return list
  if (Array.isArray(list) && list.length > 0) {
    return list.map(item => convertTemp(item, target, source, isTempDiff))
  }
  return list
}

export const convertTemp = (val, target = 2, source = 1, isTempDiff = 0) => {
  if (val === "" || val == null || isNaN(val) || source == target) return val
  let res = val * 1

  if (source == 1 && target == 2) {
    res = convertC2F(val, isTempDiff)
  } else if (source == 2 && target == 1) {
    res = convertF2C(val, isTempDiff)
  }

  return res
}

export const convertC2F = (val, isTempDiffConvert = 0) => {
  return parseFloat(((val * 9) / 5 + 32 * (1 - isTempDiffConvert)).toFixed(6).toString())
}

export const convertF2C = (val, isTempDiffConvert = 0) => {
  return parseFloat((((val - 32 * (1 - isTempDiffConvert)) * 5) / 9).toFixed(6).toString())
}

export const replaceEmpty2NaN = obj => {
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      replaceEmpty2NaN(obj[key])
    } else if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      obj[key] = NaN
    }
  }
}

export const replaceNullWith0 = obj => {
  for (let key in obj) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      replaceNullWith0(obj[key])
    } else if (obj[key] === null || obj[key] === undefined || obj[key] === "--") {
      obj[key] = 0
    }
  }
}

export const assemblyCascaderList = (data = []) => {
  const maxSplitLength = Math.max(...data.map(item => item.split("_").length))
  const list = data.map(item => {
    let parts = item.split("_")
    while (parts.length < maxSplitLength) {
      parts.push("-")
    }
    return parts
  })

  const result = []
  list.forEach(item => {
    let currentLevel = result
    item.forEach((part, index, array) => {
      let existing = currentLevel.find(child => child.text === part)
      if (!existing) {
        existing = index === array.length - 1 ? { text: part, item: [...array] } : { text: part, children: [] }
        currentLevel.push(existing)
      }
      currentLevel = existing.children
    })
  })
  result.sort((a, b) => a.text.localeCompare(b.text))
  return sortCascaderChildren(result)
}

export const sortCascaderChildren = data => {
  data.forEach(item => {
    if (item.children && item.children.length > 0) {
      sortCascaderChildren(item.children)
      item.children.sort((a, b) => a.text.localeCompare(b.text))
    }
  })
  return data
}

export const getDaysInMonths = (year = new Date().getFullYear()) => {
  const daysInMonths = []
  for (let month = 0; month < 12; month++) {
    const days = new Date(year, month + 1, 0).getDate()
    daysInMonths.push(days)
  }
  return daysInMonths
}

export const getWeekdaysInMonths = (year = new Date().getFullYear()) => {
  const daysInMonths = []
  for (let month = 0; month < 12; month++) {
    const days = new Date(year, month + 1, 0).getDate()
    daysInMonths.push(days)
  }
  return daysInMonths
}

export const getWorkdaysInMonths = (year = dayjs().year(), doubleRest = true) => {
  const res = {
    weekday: Array(12).fill(0),
    weekend: Array(12).fill(0)
  }
  Array.from({ length: 12 }).map((_, month) => {
    const start = dayjs().year(year).month(month).startOf("month")
    const end = start.endOf("month")

    let workdays = 0
    let weekends = 0

    let current = start
    while (current.isBefore(end) || current.isSame(end, "day")) {
      const day = current.day()
      const isWeekend = doubleRest ? day === 0 || day === 6 : day === 0

      isWeekend ? weekends++ : workdays++
      current = current.add(1, "day")
    }
    res.weekday[month] = workdays
    res.weekend[month] = weekends
  })
  return res
}



// WEBPACK FOOTER //
// ./src/utils/convert.js